// extracted by mini-css-extract-plugin
module.exports = {"text_loader":"style_text_loader__DnyHs","active":"style_active__rolSJ","waves":"style_waves__TmJFW"};